import React from 'react'
import { UploadProductServicePrompt } from './BulkUploadSlider';
import { useSelector, useDispatch } from 'react-redux';

const SellOnlineStep = (props) =>{
  let transactionType = props.transactionType.replace('New','');
  const viaOmni=useSelector(state=>state.session.viaOmni)
  
  return (
    <div className='upload-prompt'>
        <UploadProductServicePrompt
            {...props}
            iconClass = {"icon-Product"}
            headerText = {"Single File Upload"}
            btnText = {"Upload File"}
            type = {props.bulkUploadServices ? "Service" : "Product"}
            showLoader = {props.showLoader == 'product' && props.transactionType == 'sellonline'}
            holderClass={"receiveenquiry-bold-icon"}
            transactionType={transactionType}
        />
        {
          !viaOmni && 
          <UploadProductServicePrompt
            {...props}
            holderClass = {"service-holder"}
            iconClass = {"icon-glshare1"}
            headerText = {"Category Wise File Upload"}
            btnText = {"Select Category"}
            type = {props.bulkUploadServices ? "Service" : "Product"}
            showLoader = {false}
            serviceCatFlow={"catWiseBulk"}
            transactionType={transactionType}
            catInfoText = {`Select this option to upload ${props.bulkUploadServices?'services':'products'} with category wise specification columns`}
        />
        }
        
    </div>
  )
}

export default SellOnlineStep;
